import React, { useReducer, useRef, useEffect } from 'react';
import { MenuOutline, CloseOutline } from '@olist/design-system-icons';
import { createPortal } from 'react-dom';
import { Accordion } from './Accordion/Accordion.js';
import { expandReducer, initialState, EXPAND, CLOSING, CLOSED } from './expandReducer.js';
import { Container, BodyMargin, MobileTriggerButton, Wrapper, WrapperLogo, LogoLink, StyledTooltip } from './styles.js';
import Button from '../Button/Button.js';

function SideNavigation({ tree, AppLogo, insideGrid, }) {
    const { brandNode, sideNavigationTree } = tree;
    const [state, dispatch] = useReducer(expandReducer, initialState);
    const handleExpanded = () => {
        if (state.isExpanded) {
            dispatch({ type: CLOSING });
        }
        if (!state.isExpanded) {
            dispatch({ type: EXPAND });
        }
    };
    const handleAnimation = () => {
        if (!state.isExpanded && state.startAnimation) {
            dispatch({ type: CLOSED });
        }
    };
    const mobileSideNavigationButtonRef = useRef(null);
    const sideNavigationButtonRef = useRef(null);
    const accordionItems = sideNavigationTree.nodes;
    useEffect(() => {
        if (state.isExpanded && sideNavigationButtonRef.current) {
            sideNavigationButtonRef.current.focus();
        }
        if (!state.isExpanded && mobileSideNavigationButtonRef.current) {
            mobileSideNavigationButtonRef.current.focus();
        }
    }, [state.isExpanded]);
    return (React.createElement(Container, null,
        React.createElement(BodyMargin, null),
        React.createElement(MobileTriggerButton, { variation: "secondary", size: "medium", icon: MenuOutline, onClick: () => dispatch({ type: EXPAND }), type: "button", ref: mobileSideNavigationButtonRef, insideGrid: insideGrid, "aria-label": state.isExpanded ? 'close navigation' : 'open navigation' }),
        createPortal(React.createElement(Wrapper, { isSideNavExpanded: state.isExpanded, startAnimation: state.startAnimation, onAnimationEnd: handleAnimation },
            React.createElement(WrapperLogo, { isSideNavVisible: state.isVisible },
                state.isVisible && (React.createElement(LogoLink, { href: brandNode.url, "aria-label": brandNode.name, "data-tracking-name": brandNode.name, "data-tracking-props": { isSideNavigation: true }, isSideNavVisible: state.isVisible, isClosing: !state.isExpanded && state.isVisible }, AppLogo !== null && AppLogo !== void 0 ? AppLogo : null)),
                React.createElement(StyledTooltip, { content: state.isExpanded ? 'fechar navegação' : 'abrir navegação', side: "right" },
                    React.createElement(Button, { variation: "secondary", size: "medium", icon: state.isExpanded ? CloseOutline : MenuOutline, onClick: handleExpanded, type: "button", ref: sideNavigationButtonRef, tabIndex: 1, style: {
                            position: 'absolute',
                            right: state.isVisible ? 0 : 'unset',
                        }, "aria-label": state.isExpanded ? 'close navigation' : 'open-navigation' }))),
            React.createElement(Accordion, { items: accordionItems, isSideNavExpanded: state.isExpanded, startAnimations: state.startAnimation, isSideNavVisible: state.isVisible, onChange: handleExpanded })), document.body)));
}

export { SideNavigation };
